module.exports = __webpack_public_path__ + "img/pay-zfb-icon.bd844ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/pay-zfb-icon.png
// module id = 4cfy
// module chunks = 1